<div class="faq-container">
  <h2>Frequently Asked Questions</h2>
  <p class="intro">What would you like to do today? Please select what you would like to do or call 234-567-8901 for help.</p>

  <div *ngFor="let faq of faqs; let i = index" class="faq-item">
    <div class="faq-question" (click)="toggle(i)">
      <span>{{ faq.question }}</span>
      <span class="arrow" [class.open]="faq.open"></span>
    </div>
    <div class="faq-answer" *ngIf="faq.open">
      {{ faq.answer }}
    </div>
  </div>
</div>

